import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'appFormatBytes' })
export class FormatBytesPipe implements PipeTransform {
    transform(bytes: number) {
        const UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const factor = 1024;
        let index = 0;

        while (bytes >= factor) {
            bytes /= factor;
            index++;
        }
        if (!bytes) {
            return '';
        }
        return parseFloat(bytes.toFixed(2)) + ' ' + UNITS[index];
    }
}
